import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import HighlightsBar from "@/components/site/HighlightsBar";
import Uses from "@/components/site/Uses";
import LoanOfficer from "@/components/site/LoanOfficer";
import FAQ from "@/components/site/FAQ";
import ContactForm from "@/components/site/ContactForm";
import PreFooterCTA from "@/components/site/PreFooterCTA";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <HighlightsBar />
        <Uses />
        <LoanOfficer />
        <FAQ />
        <ContactForm />
        <PreFooterCTA />
      </main>
      <Footer />
    </div>
  );
}
